export default __webpack_public_path__ + "static/media/health_check_female_3x2_Hk.eb9e8179.webp";